<template>
	<div style="height: 100%;">
		<page class="visitor" v-if="$route.path === '/visitor'">
			<zui-header :borderGrey="true" :navConfigList="navConfigList" :wenjuan="true"></zui-header> 
			<PageNavigater></PageNavigater>
			<!--游客须知-->
			<cms-column-list id="one" :pid="$cid.visitor.youKeXuZhi" class="one mobileOne" @loaded="youKeXuZhiLoaded">
				<template slot-scope="{list}">
					<div class="title"></div>
					<div class="contain">
						<div class="tab">
							<div class="tab-item" :class="{ active: oneTab === index }" v-for="(item, index) in list"
								:key="item.id" @click="tab(index)">{{ item.name }}
							</div>
						</div>
						<!--swiper-no-swiping 解决了滚动条可以拖动的问题 但是出现了内容框内无法左右手势滑动-->
						<swiper class="swiper" :options="swiperOption1" ref="mySwiper1" @slideChange="onSlideChange1">
							<swiper-slide class="content vivify fadeIn delay-500" v-for="(slide,index) in youKeXuZhi"
								:key="index">
								<el-scrollbar style="height:100%" ref="scrollVisitor" class="swiper-no-swiping">
									<div v-html="slide.note">
									</div>
								</el-scrollbar>
							</swiper-slide>
						</swiper>
					</div>
				</template>
			</cms-column-list>
			<!--景区热线-->
			<cms-column :id="$cid.visitor.jingQuReXian" :parse-function="jingQuReXianParse" class="one">
				<template slot-scope="{data}">
					<div class="contain">
						<div class="contact flex">
							<div class="phone">
								<img :src="rexian" alt="" />
								<span>{{ data.name }}</span>
								<!--<span>景<br>区<br>热<br>线</span>-->
							</div>
							<div class="number">
								<p>{{ data.title }}</p>
								<div class="flex">
									<div class="left">
										<div v-for="(item, index) in data.leftList" :key="index">{{ item }}</div>
									</div>
									<div class="right">
										<div v-for="(item, index) in data.rightList" :key="index">{{ item }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</template>
			</cms-column>
			<div class="two" id="two">
				<div class="contain">
					<div class="title">活动·资讯</div>
					<div class="content">
						<cms-column-list :pid="$cid.visitor.huoDongZiXun" class="tab" @loaded="twoTabColumnLoaded">
							<template slot-scope="{list}">
								<div :class="{ active: twoTab === index }" @click="tab1(index, list)" class="tab-item"
									v-for="(item, index) in list" :key="item.id">{{ item.name }}
								</div>
								<div class="more" @click="activityMore">查看更多</div>
							</template>
						</cms-column-list>
						<cms-article-list :pid="twoTabId" :limit="6" unshift unshiftLimit
							class="article flex vivify fadeInTop delay-1000" :class="isIE ? 'classie' : ''"
							@loaded="twoTabLoaded">
							<div class="left">
								<div class="article-item" v-for="item in twoTabLeftList" :key="item.id">
									<div class="grey">{{ item.createTime.substring(0, 10) }}</div>
									<p @click="$openNewWindow('/new/visitor/activity/info?id=' + item.id)">{{ item.title }}</p>
									<div class="grey" @click="$openNewWindow('/new/visitor/activity/info?id=' + item.id)">{{ item.intro }}</div>
									<div class="more" @click="$openNewWindow('/new/visitor/activity/info?id=' + item.id)">
										<a class="no_hover">查看详情</a>
									</div>
								</div>
								<div v-if="twoTabLeftList.length === 0">暂无内容</div>
							</div>
							<swiper class="carousel" :options="swiperOptionMini">
								<swiper-slide v-for="item in twoTabRightList" :key="item.id" class="slide-1">
									<div class="right" @click="$openNewWindow('/new/visitor/activity/info?id=' + item.id)">
										<div class="grey">{{ item.createTime.substring(0, 10) }}</div>
										<p>{{ item.title }}</p>
										<div class="grey">{{ item.intro }}</div>
										<cms-image :src="item.cover"></cms-image>
									</div>
								</swiper-slide>
								<div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
							</swiper>
						</cms-article-list>
					</div>
				</div>
			</div>
			<div class="three" id="three">
				<div class="contain">
					<div class="title">票价·信息</div>
					<div class="weather">
						<div class="line-sign">
							<em class="el-icon-caret-right"></em>
						</div>
						<div class="wea-info">
							<span class="top">峨眉山</span>
							<img :src="weather.icon" alt="" v-show="weather.icon != ''" class="temp-icon">
							<div class="temp-text">
								<p>{{ weather.date }}</p>
								<p>{{ weather.temp }}</p>
							</div>
						</div>
					</div>
					<div class="info flex vivify fadeInTop">
						<cms-column :id="$cid.visitor.piaoJiaXinXi" class="left">
							<template slot-scope="{data}">
								<div class="text">官方购票</div>
								<div class="img">
									<cms-image :src="data.cover"></cms-image>
								</div>
								<div class="xieti">
									<div>扫码关注微信公众号</div>
									<div>官网售票渠道 更优惠 更快捷</div>
								</div>
								<div class="button" @click="piaoJiaXinXiBtnClick(data)">{{ data.ext1value }}</div>
							</template>
						</cms-column>
						<cms-column-list :pid="$cid.visitor.piaoJiaXinXi" class="right vivify fadeInBottom delay-1000"
							@loaded="piaoJiaXinXiLoaded">
							<template slot-scope="{list}">
								<div class="tab flex">
									<div class="tab-item" :class="{ active: threeTab === index }"
										@click="tab2(index, list)" v-for="(item, index) in list" :key="item.id">
										{{ item.name }}
									</div>
								</div>
								<div class="content" v-html="piaojiaXinxiContent"></div>
							</template>
						</cms-column-list>
					</div>
				</div>
			</div>
			<div class="four" id="four">
				<div class="contain">
					<div class="title">交通·指引</div>
					<cms-column-list :pid="jiaoTongZhiYin" class="tab flex" @loaded="tab3">
						<template slot-scope="{list}">
							<div class="tab-item" :class="{ active: fourTab === index }" @click="tab3(list, index)"
								v-for="(item, index) in list" :key="item.id">
								{{ item.name ? item.name.replace(/\uFF08(.+?)\uFF09/g,"") : '' }}
							</div>
						</template>
					</cms-column-list>
					<div class="header">{{ fourData.name ? fourData.name.replace(/\uFF08(.+?)\uFF09/g,"") : ''}}</div>
					<div class="line-white"></div>
				</div>
				<div class="home">
					<cms-article-list :pid="fourData.id" class="sw-box vivify fadeIn delay-1000">
						<template slot-scope="{list}">
							<swiper class="swiper" :options="swiperOption" @slideChange="onSlideChange" ref="mySwiper">
								<swiper-slide v-for="item in list" :key="item.id">
									<div class="icon">
										<cms-image :src="cmsIcon"></cms-image>
									</div>
									<div class="carousel-title">{{ item.title }}</div>
									<div class="line">
										<div class="img"></div>
									</div>
									<div class="carousel-content">
										<div>{{ item.intro }}</div>
										<cms-image :src="item.cover"></cms-image>
									</div>
								</swiper-slide>
							</swiper>
							<div class="swiper-button-next swiper-button-white" slot="button-next">
								<div class="btn"></div>
							</div>
							<div class="swiper-button-prev swiper-button-white" slot="button-prev">
								<div class="btn"></div>
							</div>
						</template>
					</cms-article-list>
					<div class="swiper-pagination" slot="pagination"></div>
				</div>
			</div>
			<div class="five-split"></div>
			<!-- <div class="five" id="five">
				<div class="title"></div>
				<div class="contain">
					<div class="refresh_btn" @click="loadGetTicket(1)">
						<img src="../assets/img/refresh_btn.png" alt="">
						<span>刷新数据</span>
					</div>
					<div class="tab-title">景区余票数据</div>
					<table border="1" class="table">
						<tr>
							<th>日期</th>
							<th v-for="(item, index) in ticketHtml" :key="index">
								<div :class="{ active: nextSevenIndex === index }">{{ item.statDate }}</div>
							</th>
						</tr>
						<tr>
							<td>
								<div>门票余量</div>
							</td>
							<td v-for="(item, index) in ticketHtml" :key="index">
								<div :class="{ active: nextSevenIndex === index }">{{ item.mpSurplusNum }}</div>
							</td>
						</tr>
						<tr>
							<td>
								<div>高山区观光车票余量</div>
							</td>
							<td v-for="(item, index) in ticketHtml" :key="index">
								<div :class="{ active: nextSevenIndex === index }">{{ item.highCarSurplusNum }}</div>
							</td>
						</tr>
					</table>
					<table border="1" class="table1">
						<tr>
							<th>日期</th>
							<th>门票余量</th>
							<th>高山区观光车票余量</th>
						</tr>
						<tr v-for="(item, index) in ticketHtml" :key="index">
							<td>
								<div :class="{ active: nextSevenIndex === index }">{{ item.statDate }}</div>
							</td>
							<td>
								<div :class="{ active: nextSevenIndex === index }">{{ item.mpSurplusNum }}</div>
							</td>
							<td>
								<div :class="{ active: nextSevenIndex === index }">{{ item.highCarSurplusNum }}</div>
							</td>
						</tr>
					</table>
					<zui-toast v-if="toastText!==''">
						{{toastText}}
					</zui-toast>
					<div class="bottomInfo">※ 展示未来七日票务余票数据</div>
				</div>
			</div> -->
			<zui-footer @toTop="toTop" />

		</page>
		<router-view v-else></router-view>
	</div>
</template>
<script>
	import './less/visitor.css'
	import Logo from '../components/Logo'
	import ZuiButton from '../components/Button'
	import {
		swiper,
		swiperSlide
	} from 'vue-awesome-swiper';
	import 'swiper/css/swiper.css';
	import axios from 'axios';
	import moment from "moment";
	import ZuiToast from '../components/Toast'

	export default {
		components: {
			Logo,
			ZuiButton,
			ZuiToast,
			swiper,
			swiperSlide
		},
		data() {
			return {
				jiaoTongZhiYin: '',
				jingQuReXianParse: item => {
					const items = item.note ? item.note.split('\n') : [];
					if (items.length <= 2) {
						item.leftList = items;
						item.rightList = [];
					} else {
						item.leftList = items.slice(0, 2);
						item.rightList = items.slice(2);
					}
					return item;
				},
				swiperOption1: {
					slidesPerView: 1,
					centeredSlides: true,
					spaceBetween: 30,
				},

				swiperOption: {
					effect: 'coverflow',
					grabCursor: true,
					centeredSlides: true,
					slidesPerView: 'auto',
					coverflowEffect: {
						rotate: 50,
						stretch: 0,
						depth: 100,
						modifier: 1,
						slideShadows: true
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					}
				},
				swiperOptionMini: {
					spaceBetween: 20,
					// effect: 'fade',
					pagination: {
						el: '.swiper-pagination',
						clickable: true
					},
					autoplay: true
				},
				oneTab: 0,
				twoTab: 0,
				twoTabId: null,
				twoTabLeftList: [],
				twoTabRightList: [],
				threeTab: 0,
				piaojiaXinxiContent: '',
				fourTab: 0,
				fourData: {},
				youKeXuZhi: [],
				rexian: require('../assets/img/rexian.png'),
				cmsIcon: require('../assets/img/four-icon.png'),
				nextSevenIndex: 0,
				navConfigList: [{
						name: "游客<br>须知",
						id: "one",
						height: "753"
					},
					{
						name: "活动<br>资讯",
						id: "two",
						height: "1453"
					},
					{
						name: "票价<br>信息",
						id: "three",
						height: "2173"
					},
					{
						name: "景区<br>交通",
						id: "four",
						height: "2993"
					},
					// {
					// 	name: "余票<br>数据",
					// 	id: "five",
					// 	height: "3728"
					// },
				],
				ticketHtml: [],
				weather: {
					icon: '',
					date: moment().format('YYYY.MM.DD'),
					temp: ''
				},
				isIE: false,
				isUC: false,
				toastText:'',
			}
		},
		created() {
			this.loadGetTicket();
			if (document.documentMode)
				this.isIE = true;
			if (navigator.appVersion.indexOf('UBrowser/'))
				this.isUC = true;
			if ((this.isIE || this.isUC) && !document.body.scrollTo) {
				Element.prototype.scrollTo = function(option) {
					this.scrollLeft = option.left;
					this.scrollTop = option.top;
				};
			}
		},
		mounted() {
			this.getWeather();
			// footer点击游客须知跳转过来的
			if (this.$route.query.tourists) {
				document.body.scrollTop = document.documentElement.scrollTop = 0;
			}
			if (document.getElementsByClassName('zui-page')[0].getAttribute("class").includes("mobileClass")) {
				this.jiaoTongZhiYin = this.$cid.visitor.jiaoTongZhiYinMobile
			} else {
				this.jiaoTongZhiYin = this.$cid.visitor.jiaoTongZhiYin
			}


		},
		methods: {
			getWeather() {
				axios.get('https://zylsweather.lintrondata.com/weatherkit/weatherjson/emeishan').then(res => {
					if (res.data.resultcode == 0) {
						// 现在温度
						this.weather.temp = res.data.weatherJson.today.nowTemp + ' ' + res.data.weatherJson.today
							.weatherSummary;
						// 天气线型图标站内地址
						this.weather.icon = res.data.weatherJson.today.weatherDayLineIconHttpsUrl;
					}
				});
			},
			onSlideChange() {
				console.log('slide change');
			},
			onSlideChange1() {
				this.oneTab = this.$refs.mySwiper1.swiper.realIndex;
			},
			loadGetTicket(num) {
				var that = this;
				// 2022.10.17 切换川大制胜数据接口
				axios.get(
						"https://www.zyou.cloud/bigdataapi/bigdata/api/emsticket/queryTicketAndHighTicketStatisc", {
							params: {
								date: '',
								interval: 6
							}
						})
					.then(result => {
						var res = result.data
						if(num === 1){
							this.toastText = '数据已刷新';
							setTimeout(() => {
								this.toastText = ''
							},1500)
						}
						if (res.code == 200) {
							let data = JSON.parse(JSON.stringify(res.results));
							that.TicketInfo = data.length ? JSON.parse(JSON.stringify(data[0])) : {};
							const ticketList = JSON.parse(JSON.stringify(data));
							// 如果余票数量小于0则设为0
							for (const ticketItem of ticketList) {
								if (ticketItem.highCarSurplusNum < 0) {
									ticketItem.highCarSurplusNum = 0;
								}
								if (ticketItem.mpSurplusNum < 0) {
									ticketItem.mpSurplusNum = 0;
								}
							}
							that.ticketHtml = ticketList;
							that.surplusTicket = data.length ? JSON.parse(JSON.stringify(data[0])) : [];
							//请求内部接口替换部分数据
							that.loadGetTicketUpdata()
						} else {
							console.warn('余票数据获取失败');
						}

						this.$nextTick(() => {
							if (this.$route.query.tickets) {
								const targetDiv = document.getElementById('five');
								targetDiv.scrollIntoView();
								document.body.scrollTo(0, document.body.scrollTop + targetDiv
									.getBoundingClientRect().top);
								// document.body.scrollTop = 500 * window.app_scale;
							}
						});
					});
			},

			loadGetTicketUpdata() {
				var that = this;
				axios.get(
						"http://ypts.lintrondata.com/ypa/remainingTickets/listRemainingTickets?interval=6", {})
					.then(result => {
						var res = result.data
						if (res.code == 200) {
							let data = JSON.parse(JSON.stringify(res.data));
							for (let i of data) {
								for (let y = 0; y < that.ticketHtml.length; y++) {
									if (i.statDate == that.ticketHtml[y].statDate) {
										that.ticketHtml[y].statDate = i.statDate
										if (i.mpSurplusNum != 999999) {
											that.ticketHtml[y].mpSurplusNum = i.mpSurplusNum
										}
										if (i.highCarSurplusNum != 999999) {
											that.ticketHtml[y].highCarSurplusNum = i.highCarSurplusNum
										}
									}
									if (i == 0 && i.statDate == that.ticketHtml[y].statDate) {
										that.TicketInfo = i
										that.surplusTicket = i
									}
								}
							}
						} else {
							console.warn('余票数据获取失败');
						}
					})
				// that.random_ticket();
			},
			random_ticket() {
				let _t = this;
				clearInterval(_t.interval);
				_t.interval = setInterval(function() {
					_t.loadGetTicket();
				}, 60000);
			},
			youKeXuZhiLoaded(list) {
				this.youKeXuZhi = list.map(item => {
					item.note = item.note ? item.note.replace(/\n/g, '<br>') : '暂无内容';
					return item;
				});
				if (this.$route.query.preferential) {
					document.body.scrollTop = document.documentElement.scrollTop = 0;
					this.tab(2);
				}
			},
			tab(index) {
				this.oneTab = index
				this.$refs.mySwiper1.swiper.slideTo(index, 300)
			},
			tab1(index, list) {
				if (this.twoTab !== index) {
					this.twoTab = index;
					this.twoTabId = list[index].id;
				}
			},
			twoTabColumnLoaded(list) {
				if (!this.twoTabId)
					this.twoTabId = list[0].id;
			},
			activityMore() {
				this.$openNewWindow(`/new/visitor/activity?id=${this.twoTabId}`);
			},
			twoTabLoaded(list) {
				if (list.length <= 2) {
					this.twoTabLeftList = list;
					this.twoTabRightList = [];
				} else {
					this.twoTabLeftList = list.slice(0, 2);
					this.twoTabRightList = list.slice(2, 6);
				}
			},
			tab2(index, list) {
				if (this.threeTab !== index) {
					this.threeTab = index;
					this.piaojiaXinxiContent = list[index].note.replace(/\n/g, '<br>');
				}
			},
			tab3(list, index = 0) {
				this.fourTab = index
				this.fourData = {
					id: list[index].id,
					name: list[index].name
				}
			},
			piaoJiaXinXiLoaded(list) {
				this.piaojiaXinxiContent = list[0].note.replace(/\n/g, '<br>');
			},
			piaoJiaXinXiBtnClick(data) {
				window.open(data.ext2value);
			},
			toTop() {
				if (this.isIE || this.isUC)
					this.$children[0].$refs['scrollview'].$refs['wrap'].scrollTop = 0;
				else
					this.$children[0].$refs['scrollview'].$refs['wrap'].scrollTo({
						top: 0,
						behavior: 'smooth'
					})
			}

		},
	}
</script>



// WEBPACK FOOTER //
// src/views/visitor.vue